<template>
  <div id="app" class="app">
    <NavBar />

    <router-view />

    <TrustpilotWidget class="tp-widget" />

    <FooterInfo />

    <CookieBanner />

    <LoadingPanel v-if="showLoadingPanel" />
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";
import LoadingPanel from "@/components/LoadingPanel";
import TrustpilotWidget from "@/components/TrustpilotWidget";
import axiosInstance from "@/utility/axiosInstance";
import CookieBanner from "@/components/CookieBanner.vue";
import FooterInfo from "@/components/FooterInfo.vue";
import { mapActions } from "vuex";

export default {
  name: "AppRoot",
  computed: {
    showBackBtn() {
      return this.$store.state.uiState.showBackBtn;
    },
    showLoadingPanel() {
      return this.$store.state.uiState.isLoading;
    },
  },
  methods: {
    ...mapActions(["fetchFeatureFlags"]),
    shouldShowUserbackWidget() {
      if (process.env["VUE_APP_SHOW_USERBACK"] === "1") {
        return new Promise((resolve) => resolve(true));
      }

      return axiosInstance
        .get("/config/feedback")
        .then(() => true)
        .catch(() => false);
    },
    loadUserbackWidget() {
      if (process.env.VUE_APP_SHOW_USERBACK === "0") {
        return;
      }

      this.shouldShowUserbackWidget().then((shouldShow) => {
        if (shouldShow) {
          window.Userback = window.Userback || {};
          // eslint-disable-next-line no-undef
          Userback.access_token =
            "10094|20006|JYuUMoe7dTwA4O50QkA2ZIgjA63SpHvOaSkgUrFvubQVld694C";
          (function(d) {
            const s = d.createElement("script");
            s.async = true;
            s.src = "https://static.userback.io/widget/v1.js";
            (d.head || d.body).appendChild(s);
          })(document);
        }
      });
    },
  },
  created() {
    this.loadUserbackWidget();
    this.fetchFeatureFlags();
  },
  components: {
    CookieBanner,
    NavBar,
    LoadingPanel,
    FooterInfo,
    TrustpilotWidget,
  },
};
</script>

<style lang="scss">
.app {
  /*overflow-y: hidden;*/
  min-height: calc(100vh - 11rem);

  @include media("<medium") {
    min-height: calc(100vh - 5.5rem);
  }
}

.tp-widget {
  margin-bottom: $spacing-small;
}
</style>
